import { render, staticRenderFns } from "./modal-3.vue?vue&type=template&id=850eee1e"
import script from "./modal-3.vue?vue&type=script&lang=js"
export * from "./modal-3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports